import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// @mui
import { styled, alpha } from "@mui/material/styles";
import DashBoardIcon from "../../assets/images/logo.svg";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  Box,
  Link,
  Button,
  Drawer,
  Typography,
  Avatar,
  Stack,
} from "@mui/material";
// mock
// hooks
import useResponsive from "../hooks/useResponsive";
// components
import Scrollbar from "../../components/scrollbar";
import NavSection from "../../components/nav-section/index";
//
import navConfig from "./config";
import { isEmailAllowedForMembers } from "../../utils/auth";

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isDesktop = useResponsive("up", "lg");

  const serializedObject = sessionStorage?.getItem("userDetails");
  const userDetails = serializedObject ? JSON.parse(serializedObject) : null;
  const adminEmail = userDetails?.email || "";

  const filteredNavConfig = navConfig.filter((item) => {
    if (item.path === "/Dashboard/users" || item.path === "/Dashboard/dailyTransactions") {
      return isEmailAllowedForMembers(adminEmail);
    }
    return true;
  });

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const renderContent = (
    <Box
      sx={{
        height: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Scrollbar
        sx={{
          padding: "10px",
          height: "calc(100% - 70px)",
          "& .simplebar-content": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box sx={{ px: 12, py: 3, display: "inline-flex" }}>
          <img src={DashBoardIcon} alt="jsddhbd" />
        </Box>
        <NavSection data={filteredNavConfig} />
      </Scrollbar>
      <Box sx={{ px: 2.5, pb: 3, mt: "auto" }}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{
            borderRadius: "8px",
            borderColor: "#d500f9",
            color: "#d500f9",
            '&:hover': {
              borderColor: "#a100c6",
              backgroundColor: "rgba(213, 0, 249, 0.04)"
            }
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: "background.default",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
